export const RESUME_GAME_POPUP_COMPONENT_TOKEN = Symbol('RESUME_GAME_POPUP_COMPONENT_TOKEN');

export interface IResumeGamePopupComponent {
  show(): Promise<void> | void;
}
